import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import React, { useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import GlossaryTable from "../Chapters/GlossaryTable.js";
import { h1style } from "./ChapterList.js";

const Glossary = () => {
  const [expanded, setExpanded] = useState(false);
  const [activeButton, setActiveButton] = useState(null);

  const panel1Ref = useRef(null);
  const panel2Ref = useRef(null);
  const panel3Ref = useRef(null);
  const panel4Ref = useRef(null);

  const annexureRowOne = [
    {
      data1: "Accused",
      data2: (
        <>
          <p>
            The accused is the party who has been charged with the commission of
            an offence/crime, to be proved before a court of law.{" "}
          </p>
        </>
      ),
    },
    {
      data1: "Advocates",
      data2: (
        <>
          <p>
            In India, an advocate is any person entered in any roll maintained
            under the provisions of the Advocates Act, 1961 and also includes
            government pleaders/advocates and officers of the department of
            prosecution.
          </p>
        </>
      ),
    },
    {
      data1: "Administrative Section",
      data2: (
        <>
          <p>
            Administrative Section refers to the spaces utilised by Court staff
            to carry out their respective functions and duties.{" "}
          </p>
        </>
      ),
    },
    {
      data1: "Arbitration",
      data2: (
        <>
          <p>
            Arbitration is a method of dispute resolution outside courts, where
            the parties appoint a neutral third party (the arbitrator) for
            dispute settlement.
          </p>
        </>
      ),
    },
    {
      data1: "Bailiff",
      data2: "Bailiff",
    },

    {
      data1: "Bar Association",
      data2: (
        <>
          <p>
            A professional body or organisation of lawyers which is responsible
            for regulating the conduct of the lawyers in that jurisdiction and
            is dedicated to meeting the needs of its members.{" "}
          </p>
        </>
      ),
    },
    {
      data1: "Bench Clerk",
      data2: (
        <>
          <p>
            A Bench Clerk is a law officer who takes care of the day-to-day
            needs of the Bench during proceedings. They maintain records such as
            the daily court fee book, maintain the Memorandum book, update the
            daily board, etc.{" "}
          </p>
        </>
      ),
    },

    {
      data1: "Building Committee",
      data2: (
        <>
          <p>
            A Building Committee is a High Court Committee that deals with
            matters of all buildings in the High Court, District Courts,
            residences of the staff and Judges and all other matters of the
            physical infrastructure of all Courts under the jurisdiction of that
            specific High Court.
          </p>
        </>
      ),
    },
    {
      data1: "Cadre",
      data2: (
        <>
          <p>
            A ‘cadre officer’ is a member of the judicial service, who may
            occupy a specific ‘cadre post’ based on the different hierarchical
            levels in the system.
          </p>
        </>
      ),
    },
    {
      data1: "Case Display Number ",
      data2: (
        <>
          <p>
            A Case Display Number is a unique identifier or a code for a
            specific case in any jurisdiction.
          </p>
        </>
      ),
    },
    {
      data1: "Causelist",
      data2: (
        <>
          <p>
            A causelist is a schedule of Court cases or matters to be heard,
            providing details such as case names, numbers, and hearing times.
            Courts typically have daily causelists, weekly causelists,
            supplementary causelists and miscellaneous causelists.
          </p>
        </>
      ),
    },

    {
      data1: "Civil Cases",
      data2: (
        <>
          <p>
            Civil Cases are cases that involve disputes between people or
            businesses over money or some injury to personal rights.
          </p>
        </>
      ),
    },
    {
      data1: "Civil Judge",
      data2: (
        <>
          <p>
            A civil judge is a judicial officer responsible for presiding over
            civil cases.
          </p>
        </>
      ),
    },
    {
      data1: "Court Point",
      data2: (
        <>
          <p>
            Court Point refers to the courtroom or any place where the Court is
            physically convened, or the place where a Commissioner or an
            inquiring officer holds proceedings under the directions of the
            Court as per the Model Video Conferencing Rules.
          </p>
        </>
      ),
    },
    {
      data1: "Criminal Cases",
      data2: (
        <>
          <p>
            Criminal cases are legal proceedings initiated by the state or
            government to prosecute an individual or entity for committing a
            criminal offence which is an act or omission that is prohibited and
            punishable under the criminal laws.
          </p>
        </>
      ),
    },
    {
      data1: "CSS Schemes",
      data2: (
        <>
          <p>
            Centrally Sponsored Schemes (“CSS”) Schemes are State-run Schemes
            that are funded by the Centre as well as the State for development
            in specialized sectors. The CSS for Development of Infrastructural
            Facilities for the Judiciary aims at improving the physical
            infrastructure of Courts at the District level as well as the
            housing needs of judicial officers to facilitate better justice
            delivery.
          </p>
        </>
      ),
    },
    {
      data1: "Dais",
      data2: (
        <>
          <p>
            The dais is a raised platform towards one side of the court, upon
            which the presiding officer/judge of that court sits while the court
            is in session.
          </p>
        </>
      ),
    },
    {
      data1: "Digital Courts Technology Officer",
      data2: (
        <>
          <p>
            The DCTO is an officer identified under Phase III of the e-Courts
            Vision document who will lead the design, execution and
            implementation of the Digital Infrastructure in the transitory stage
            of Phase III.
          </p>
        </>
      ),
    },
    {
      data1: "Defence Lawyer",
      data2: (
        <>
          <p>
            The defence lawyer is the advocate representing the defendant in a
            lawsuit or criminal proceedings.
          </p>
        </>
      ),
    },
    {
      data1: "Deposition Room",
      data2: (
        <>
          <p>
            A deposition is a testimony made under oath and taken down in
            writing by an authorised officer of the court, typically in an
            out-of-court setting and before trial. A deposition room is a room
            designed for a victim or a defendant to give their deposition in a
            safe and comfortable manner.
          </p>
        </>
      ),
    },
    {
      data1: "Disposed Cases",
      data2: (
        <>
          <p>
            A Disposed Case is a case which has reached its final conclusion or
            has been settled by the Court.
          </p>
        </>
      ),
    },
    {
      data1: "Display Board",
      data2: (
        <>
          <p>
            A Display Board is a live tracker used to inform litigants and
            lawyers regarding the status of ongoing proceedings in a Courtroom,
            cases listed or disposed off in other Courtrooms throughout the
            Court Complex, etc.
          </p>
        </>
      ),
    },
    {
      data1: "District Court",
      data2: (
        <>
          <p>
            A District Court is a subordinate court as under Articles 233-237 of
            the Constitution, set up in each district and vested with both civil
            and criminal jurisdiction. A District Court complex may comprise
            civil and criminal courts, as well as other Special Courts set up
            under specific legislations such as a POCSO Court, a Family Court,
            an NDPS court, etc., Ordinarily, a district court is the first point
            of contact with the judicial system.
          </p>
        </>
      ),
    },
    {
      data1: "District Legal Services Authority",
      data2: (
        <>
          <p>
            The DLSA is an authority set up at the District Court level to
            facilitate legal aid to all such persons who cannot afford the same,
            and implement Legal Aid Programmes and Schemes at the District
            level. The District Judge of the District is its ex-officio
            Chairman.
          </p>
        </>
      ),
    },
    {
      data1: "e-Courts ",
      data2: (
        <>
          <p>
            The e-Courts project under the supervision of the eCommittee of the
            Supreme Court of India seeks to provide and implement information
            and communication technology (ICT) in courts and allied services to
            make the judicial system more affordable and cost-effective.
          </p>
        </>
      ),
    },
    {
      data1: "Empanelled advocates",
      data2: (
        <>
          <p>
            Empanelled advocates are legal professionals who have been
            officially appointed or enlisted by a particular authority or
            organisation to represent them in legal matters.
          </p>
        </>
      ),
    },
    {
      data1: "e-Seva Kendra",
      data2: (
        <>
          <p>
            The DLSA is an authority set up at the District Court level to
            facilitate legal aid to all such persons who cannot afford the same,
            and implement Legal Aid Programmes and Schemes at the District
            level. The District Judge of the District is its ex-officio
            Chairman.
          </p>
        </>
      ),
    },
    {
      data1: "Electronic evidence ",
      data2: (
        <>
          <p>
            Digital evidence or electronic evidence is any probative information
            stored or transmitted in digital form that a party to a court case
            may use at trial.
          </p>
        </>
      ),
    },
    {
      data1: "Expert Witness",
      data2: (
        <>
          <p>
            An Expert Witness is an individual with specialised knowledge,
            skills, education, or experience in a particular field who may be
            called to testify in a case proceeding.
          </p>
        </>
      ),
    },
    {
      data1: "Government Pleader",
      data2: (
        <>
          <p>
            A Government Please is any officer appointed by the State Government
            to perform the functions expressly imposed by the Code of Civil
            Procedure on the Government Pleader.
          </p>
        </>
      ),
    },
    {
      data1: "Gender Sensitisation & Internal Complaints Committee ",
      data2: (
        <>
          <p>
            The GSICC is an Administrative Committee constituted at the High
            Court and the Supreme Court which has the mandate of safeguarding
            the constitutional and legal rights of women.
          </p>
        </>
      ),
    },
    {
      data1: "Harmonised Guidelines ",
      data2: (
        <>
          <p>
            Harmonised Guidelines and Standards for Universal Accessibility in
            India by the Ministry of Housing and Urban Affairs is a guidebook
            for creating the best practices and acceptable standards for
            universal accessibility in built environments.
          </p>
        </>
      ),
    },
    {
      data1: "Hearing ",
      data2: (
        <>
          <p>
            A Hearing refers to any formal proceeding before a Court or
            Alternative Dispute Forum.
          </p>
        </>
      ),
    },
    {
      data1: "His Majesty’s Courts & Tribunals Design Guide",
      data2: (
        <>
          <p>
            The HM Design Guide is a guide to the design of courts and
            tribunals. The court structure covers England and Wales while the
            tribunals system covers England, Wales and in some cases Northern
            Ireland and Scotland. The Design Guide sets out the vision and
            minimum standards for refurbishment and new building projects.
          </p>
        </>
      ),
    },
    {
      data1: "Information Kiosk ",
      data2: (
        <>
          <p>
            An information kiosk is a stand-alone counter where litigants can
            obtain information related to various court processes, fee details,
            layout of the court, consumer rights, etc.
          </p>
        </>
      ),
    },
    {
      data1: "Judicial Chambers ",
      data2: (
        <>
          <p>
            Judicial Chambers refer to the private offices of a judge or a
            judicial officer where he hears motions, signs papers, deals with
            other official matters and rests when not in a session of the Court.
          </p>
        </>
      ),
    },
    {
      data1: "Judicial Officer",
      data2: (
        <>
          <p>
            A judicial officer is a member of the judicial service, vested with
            jurisdiction to hear cases and dispense justice.
          </p>
        </>
      ),
    },
    {
      data1: "Jurisdiction ",
      data2: (
        <>
          <p>
            Jurisdiction is the authority and power to look into disputes and
            pass judgments, vested with an institution (the judiciary) and
            exercised by individuals within it (judges).
          </p>
        </>
      ),
    },
    {
      data1: "Legal Aid Services ",
      data2: (
        <>
          <p>
            Legal Aid Services are the provision of free legal services in civil
            and criminal matters for those poor and marginalised people who
            cannot afford the services of a lawyer for the conduct of a case or
            a legal proceeding in any Court, Tribunal or Authority.
          </p>
        </>
      ),
    },
    {
      data1: "Litigant ",
      data2: (
        <>
          <p>
            A litigant is the party approaching the court raising a dispute and
            seeking justice. They may also be referred to as “petitioners” or
            “applicants”.
          </p>
        </>
      ),
    },
    {
      data1: "King’s/Queen’s Justice",
      data2: (
        <>
          <p>
            This is the term used to refer to the jurisdiction vested with the
            monarch to dispense justice, particularly in reference to the
            exercise of power over a colonial subject.
          </p>
        </>
      ),
    },
    {
      data1: "Listed Case ",
      data2: (
        <>
          <p>
            A listed case is one which has appeared on the daily or weekly
            causelists for a particular court, which lays down the order of
            cases to be called for hearing before the judge on that particular
            day or week.
          </p>
        </>
      ),
    },
    {
      data1: "Magistrate ",
      data2: (
        <>
          <p>
            A Magistrate is a judicial official who acts as a judge in law
            courts which deal with minor crimes or disputes.
          </p>
        </>
      ),
    },
    {
      data1: "Mediation ",
      data2: (
        <>
          <p>
            Mediation refers to the procedure in which dispute resolution is
            undertaken through discussion between the parties with the
            assistance of a trained impartial third person(s) acting as
            mediator(s).
          </p>
        </>
      ),
    },
    {
      data1: "Mulaqat Room ",
      data2: (
        <>
          <p>
            A Mulaqat Room is a designated room where undertrial prisoners may
            have meetings with their family members or advocates.
          </p>
        </>
      ),
    },
    {
      data1: "Multipurpose Courtrooms",
      data2: (
        <>
          <p>
            Courtrooms which would be used for both civil and criminal cases.
          </p>
        </>
      ),
    },
    {
      data1: "NCMS Baseline Report ",
      data2: (
        <>
          <p>
            The 2012 Report on Court Development Planning System (Infrastructure
            and Budgeting) by the Sub-Committee of the National Court Management
            Systems (“NCMS”).
          </p>
        </>
      ),
    },
    {
      data1: "NDPS Act (1985)  ",
      data2: (
        <>
          <p>
            An Act of the Parliament of India that prohibits a person from
            producing, manufacturing, cultivating, possession, sale, purchasing,
            transport, storage, and/or consumption of any narcotic drug or
            psychotropic substance.
          </p>
        </>
      ),
    },
    {
      data1: "National Judicial Technology Council ",
      data2: (
        <>
          <p>
            The NJTC is a statutory body proposed under the Phase III Vision
            Document which will focus on designing the Digital Infrastructure
            based on consultations with all necessary stakeholders.
          </p>
        </>
      ),
    },
    {
      data1: "N-STEP ",
      data2: (
        <>
          <p>
            N-STEP is a centralised process service tracking application
            comprising of a web application and a complementary mobile app
            designed to streamline the process.
          </p>
        </>
      ),
    },
    {
      data1: "Mulaqat Room ",
      data2: (
        <>
          <p>
            A Mulaqat Room is a designated room where undertrial prisoners may
            have meetings with their family members or advocates.
          </p>
        </>
      ),
    },
    {
      data1: "Notary ",
      data2: (
        <>
          <p>
            A Notary is a legally authorised person who is empowered to
            authenticate and certify documents, administer oaths, and witness
            signatures, ensuring the authenticity and validity of documents,
            thereby facilitating their acceptance in legal proceedings and
            transactions.
          </p>
        </>
      ),
    },
    {
      data1: "Oath Commissioner ",
      data2: (
        <>
          <p>
            An Oath Commissioner is a legally authorised person empowered to
            administer oaths and affirmations to verify the truthfulness of
            statements in legal documents or during proceedings.
          </p>
        </>
      ),
    },
    {
      data1: "Online Hearing ",
      data2: (
        <>
          <p>
            Online hearing is the practice of conducting court proceedings
            through video-conferencing or other online methods.
          </p>
        </>
      ),
    },
    {
      data1: "Quiet Rooms ",
      data2: (
        <>
          <p>
            A Quiet Room is a room built with the aim of shielding noise from or
            towards the surroundings. A quiet room provides a dedicated space
            for users to relax and take a break from the noise and stimulation
            of the surroundings.
          </p>
        </>
      ),
    },
    {
      data1: "Perpetual Succession  ",
      data2: (
        <>
          <p>
            Perpetual succession refers to the continuation of a corporation's
            or other organisation's existence despite the death, bankruptcy,
            insanity, change in membership or an exit from the business of any
            owner or member, or any transfer of stock, etc.
          </p>
        </>
      ),
    },
    {
      data1: "POCSO Courts",
      data2: (
        <>
          <p>
            The Protection of Children from Sexual Offences Act (“POCSO”), 2012
            is an act enacted by the Parliament which aims to curb child sexual
            abuse by increasing penalties for sexual offences against children
            and creating a sensitive criminal justice system to support child
            victims. The POCSO Court undertakes proceedings for cases filed
            under the POCSO Act.
          </p>
        </>
      ),
    },
    {
      data1: "Prevention of Atrocities Act ",
      data2: (
        <>
          <p>
            The Prevention of Atrocities Act, 1989 is an Act enacted by the
            Parliament of India to prevent atrocities and hate crimes against
            the scheduled castes and scheduled tribes.
          </p>
        </>
      ),
    },
    {
      data1: "Process Server ",
      data2: (
        <>
          <p>
            A Process Server is a Court official who serves legal documents such
            as subpoenas, writs, or warrants, especially to those who are
            required to appear in Court.
          </p>
        </>
      ),
    },
    {
      data1: "Public Prosecutor ",
      data2: (
        <>
          <p>
            A Public Prosecutor is a law officer who conducts criminal
            proceedings on behalf of the state or in the public interest.
          </p>
        </>
      ),
    },
    {
      data1: "Registrar",
      data2: (
        <>
          <p>
            The Registrar is the head of the ministerial establishment of a
            court who exercises such powers and functions which are conferred
            upon her by the Chief Justice of the Court or the President of the
            Tribunal.
          </p>
        </>
      ),
    },
    {
      data1: "Remote Point ",
      data2: (
        <>
          <p>
            Remote Point is a place where any person is required to be present
            or appear through a video link which is not within the Courtroom.
          </p>
        </>
      ),
    },
    {
      data1: "SDG Goal ",
      data2: (
        <>
          <p>
            The SDG Goals are the Sustainable Development Goals set out by 195
            nations under the United Nations to bring together their respective
            governments, businesses, media, institutions of higher education,
            and local NGOs to improve the lives of the people in their country
            by 2030.
          </p>
        </>
      ),
    },
    {
      data1: "Sheristedar ",
      data2: (
        <>
          <p>
            Sheristedar is an administrative officer of the court who undertakes
            the function of receiving and checking out court pleas. She also
            acts as the officer responsible for the case files’ movement in and
            out of the court on a daily basis. This post may be named
            differently in other States. For example, Sheristedars are referred
            to as Ahlmads in Delhi.
          </p>
        </>
      ),
    },
    {
      data1: "Speedy Trial ",
      data2: (
        <>
          <p>
            A speedy trial denotes a legal process characterised by expediting
            court proceedings, prompt and efficient case resolution, minimising
            delays, and ensuring timely adjudication of cases upholding the
            right to timely justice.
          </p>
        </>
      ),
    },
    {
      data1: "Stakeholders ",
      data2: (
        <>
          <p>
            Stakeholders are individuals or groups with vested interests in its
            operations and outcomes, including judges, legal professionals,
            litigants, and the public.
          </p>
        </>
      ),
    },
    {
      data1: "State Bar Council ",
      data2: (
        <>
          <p>
            The State Bar Council is a body that regulates legal practice and
            education in a specific state, overseeing advocate enrollment,
            discipline, and ethical standards.
          </p>
        </>
      ),
    },
    {
      data1: " Stamp Vendor",
      data2: (
        <>
          <p>
            A stamp vendor refers to an authorised individual or entity
            responsible for selling judicial and non-judicial stamps for legal
            purposes, ensuring compliance with legal requirements.
          </p>
        </>
      ),
    },
    {
      data1: "Stenographer ",
      data2: (
        <>
          <p>
            A stenographer is an officer of the court who records the court
            proceedings.
          </p>
        </>
      ),
    },
    {
      data1: "Suo Moto ",
      data2: (
        <>
          <p>
            Suo Moto means “on its own motion”, where a government agency acts
            on its own cognizance to undertake an action.
          </p>
        </>
      ),
    },
    {
      data1: "Summons",
      data2: (
        <>
          <p>
            Summons refers to an order to appear before a judge or magistrate,
            or the writ containing such an order.
          </p>
        </>
      ),
    },
    {
      data1: "Testimonial Aids",
      data2: (
        <>
          <p>
            Testimonial Aids are technological aids used for protecting
            vulnerable victims and witnesses, to create a more comfortable
            atmosphere and make it easier for them to provide their testimony.
          </p>
        </>
      ),
    },
    {
      data1: "Testimony",
      data2: (
        <>
          <p>
            A Testimony is a declaration usually made orally by a witness under
            oath in response to interrogation by a lawyer or authorised public
            official
          </p>
        </>
      ),
    },
    {
      data1: "Undertrial",
      data2: (
        <>
          <p>
            An undertrial is a person who is in judicial custody/jail or remand
            during the investigation and trial process.
          </p>
        </>
      ),
    },
    {
      data1: "Vakalatnama",
      data2: (
        <>
          <p>
            A Vakalatnama is a legal document that authorises an advocate to
            represent a party in court proceedings.
          </p>
        </>
      ),
    },
    {
      data1: "Vulnerable Witness",
      data2: (
        <>
          <p>
            A vulnerable witness is one whose circumstances fall within the
            scope of the instances laid down in Smruti Tukaram Badade v. State
            of Maharashtra (2019 SCC OnLine SC 2122), and to whom extra
            protection and testimonial aids must be provided.
          </p>
        </>
      ),
    },
    {
      data1: "Vulnerable Witness Deposition Centres",
      data2: (
        <>
          <p>
            Following the directive of the Supreme Court in Smruti Tukaram
            Badade v. State of Maharashtra (2019 SCC OnLine SC 2122), all
            District Courts are required to set up dedicated spaces/centres,
            aimed at creating a safe and barrier-free environment for recording
            the evidence of vulnerable witnesses.
          </p>
        </>
      ),
    },
  ];
  const annexureRowTwo = [
    {
      data1: "Access with Permissions ",
      data2: (
        <>
          <p>
            Access with Permissions refers to accesses which allow entry to
            authorised individuals by using a code, OTP, or access card, to
            punch in the value and gain access to an otherwise restricted area
          </p>
        </>
      ),
    },
    {
      data1: "Access to Public Zone",
      data2: (
        <>
          <p>
            This is an area or a zone which has free access to all the
            stakeholders but has some security elements intended for crowd
            management and people counting as needed for public evacuation
            during an emergency.
          </p>
        </>
      ),
    },
    {
      data1: "Access to Service Zone",
      data2: (
        <>
          <p>
            This is an area or a zone which is accessed by all the service
            providers of the court complex. Some security elements intended for
            crowd management and people counting as needed for public evacuation
            during emergencies should be provisioned in this area/zone.
          </p>
        </>
      ),
    },
    {
      data1: "Accessible Parking",
      data2: (
        <>
          <p>
            Accessible Parking refers to parking spaces that are designated for
            the use of vehicles used by Persons with Disabilities.
          </p>
        </>
      ),
    },
    {
      data1: "Adjacency of Spaces",
      data2: (
        <>
          <p>
            Adjacency refers to the relationship and proximity between different
            rooms or spaces within a building. The concept of adjacency of
            spaces takes into consideration the functional and practical aspects
            of placing rooms near one another based on their usage, purpose, and
            the desired flow of activities.
          </p>
        </>
      ),
    },
    {
      data1: "Alighting Area",
      data2: (
        <>
          <p>
            An Alighting Area is a designated zone where individuals can safely
            disembark from vehicles. Positioned strategically near entrances or
            drop-off points, it facilitates convenient access for visitors,
            litigants, and stakeholders. This area is instrumental in ensuring
            gradual and safe vehicular movement within the complex.
          </p>
        </>
      ),
    },
    {
      data1: "Ambient Noise",
      data2: (
        <>
          <p>
            Ambient Noise refers to the sound pressure levels associated with a
            given environment. Ambient noise is usually a composite of sounds
            from near and far sources none of which are particularly dominant.
          </p>
        </>
      ),
    },
    {
      data1: "Ambulant Toilet",
      data2: (
        <>
          <p>
            Ambulant toilets are specifically designed for those with ambulant
            disabilities who do not require the extra space that is provided by
            Accessible toilets. Primarily, they are for those who do not require
            the use of a wheelchair, for example, those with sensory loss, or
            arthritis or require the use of a walking frame.
          </p>
        </>
      ),
    },
    {
      data1: "Annex Building",
      data2: (
        <>
          <p>
            An Annex building is an extension of or an addition to any existing
            building.
          </p>
        </>
      ),
    },
    {
      data1: "Approach View Point",
      data2: (
        <>
          <p>
            An Approach View Point is a strategically placed area, which
            provides clear visibility, orientation, and easy navigation for all
            visitors, including those with disabilities, by providing
            unobstructed views of entrances, directional signages, landmarks,
            etc., while incorporating accessibility features like ramps, tactile
            paving, appropriate seating, lighting, etc.
          </p>
        </>
      ),
    },
    {
      data1: "Assembly Point",
      data2: (
        <>
          <p>
            Assembly Point is a predetermined location, designated with
            appropriate signage, where building occupants are instructed to
            gather during a fire/leak/explosion or other emergency evacuation.
            The intent is to provide a clear, organised, and safe location for
            all building occupants to assemble and be accounted for.
          </p>
        </>
      ),
    },
    {
      data1: "Background Noise",
      data2: (
        <>
          <p>
            Background noise refers to the sound pressure levels in a given
            environment from all sources excluding a specific sound source being
            investigated or measured.
          </p>
        </>
      ),
    },
    {
      data1: "Beacon Alarm",
      data2: (
        <>
          <p>
            Beacon Alarms are alarms that get triggered by IOT Devices for
            communication regarding specific emergencies. For example, fire
            alarm beacons, loitering or unidentified baggage triggered by the
            Video Management System of an IP Camera Surveillance System.
          </p>
        </>
      ),
    },
    {
      data1: "Bi-Annual Access",
      data2: (
        <>
          <p>
            Bi-Annual Access refers to renewable Access that may be given to
            named & verified individuals (renewed every 6 months).
          </p>
        </>
      ),
    },
    {
      data1: "Bollards",
      data2: (
        <>
          <p>
            Bollards are short, sturdy posts strategically positioned to
            regulate traffic, enhance safety, and prevent unauthorised vehicle
            access to pedestrian areas. They also feature detectable attributes
            like contrasting colours or tactile markings, aiding navigation for
            individuals with disabilities.
          </p>
        </>
      ),
    },
    {
      data1: "Broad Band Noise",
      data2: (
        <>
          <p>
            Broad Band Noise refers to spectrum/range consisting of a large
            number of frequency components, none of which is individually
            dominant.
          </p>
        </>
      ),
    },
    {
      data1: "Building Envelope",
      data2: (
        <>
          <p>
            A Building Envelope is the physical separator between the
            conditioned and unconditioned environment of a building, including
            the resistance to air, water, heat, light, and noise transfer.
          </p>
        </>
      ),
    },
    {
      data1: "Building Management System",
      data2: (
        <>
          <p>
            A Building Management System (“BMS”) is a computer-based system
            installed in buildings to control and monitor mechanical and
            electrical equipment, such as heating, ventilation, and air
            conditioning (HVAC), lighting, and power systems.
          </p>
        </>
      ),
    },

    {
      data1: "Circadian Rhythms",
      data2: (
        <>
          <p>
            Circadian rhythms are approximately 24-hour cycles in physiology and
            behaviour that enable an organism to predict and adapt to periodic
            changes in its environment. They influence everything from
            locomotion and sleep/wake cycles to hormonal rhythms, metabolism,
            and cognitive performance.{" "}
          </p>
        </>
      ),
    },
    {
      data1: "Circulation System",
      data2: (
        <>
          <p>
            Circulation refers to the movement of people through, around and
            between buildings and other parts of the built environment. Within
            buildings, circulation spaces are spaces that are predominately used
            for circulation, such as entrances, foyers and lobbies, corridors,
            stairs, landings and so on.
          </p>
        </>
      ),
    },

    {
      data1: "Clear Width",
      data2: (
        <>
          <p>
            The clear width or distance measured between walls, handrails or any
            obstructions.
          </p>
        </>
      ),
    },
    {
      data1: "Cross Slope",
      data2: (
        <>
          <p>
            Cross Slope is the slope that is provided to the road surface in the
            transverse direction to drain rainwater from the road surface for
            water drainage and quick disposal from the pavement surface.
          </p>
        </>
      ),
    },
    {
      data1: "Cross Talk",
      data2: (
        <>
          <p>
            Cross Talk refers to the unwanted sound transmission between one
            room and another room or space via a duct.
          </p>
        </>
      ),
    },
    {
      data1: "Decibels",
      data2: (
        <>
          <p>
            A Decibel (dB) is a unit used to measure the intensity or magnitude
            of a sound or the ratio of two different power levels, often used in
            audio, acoustics, and telecommunications to quantify sound levels.
          </p>
        </>
      ),
    },
    {
      data1: "Design Tenets",
      data2: (
        <>
          <p>
            Design Tenets refer to the criteria that shape a vision and define
            how to perform a design process.
          </p>
        </>
      ),
    },
    {
      data1: "Designated Space ",
      data2: (
        <>
          <p>
            Designated Space refers to a designated area or feature identified
            and managed to maintain its unique special character or purpose. For
            example, designated parking, seating, entrances, etc.
          </p>
        </>
      ),
    },
    {
      data1: "Detailed Project Report (DPR)",
      data2: (
        <>
          <p>
            A Detailed Project Report details all the tasks and elements
            necessary for the completion of the project.
          </p>
        </>
      ),
    },
    {
      data1: "DG Set",
      data2: (
        <>
          <p>
            A Diesel Generator (“DG”) set (also known as a diesel genset) is the
            combination of a diesel engine with an electric generator (often an
            alternator) to generate electrical energy.
          </p>
        </>
      ),
    },
    {
      data1: "Dry Moat",
      data2: (
        <>
          <p>
            A Dry Moat is a trench surrounding the perimeter of the building,
            serving both aesthetic and practical purposes like drainage and
            boundary definition. It is historically associated with defence. In
            the contemporary context, it primarily adds visual interest to the
            landscape while potentially acting as a barrier to unauthorised
            access.
          </p>
        </>
      ),
    },
    {
      data1: "Empathetic Signage System",
      data2: (
        <>
          <p>
            An Empathetic Signage System is a signage system, incorporating
            clear language, intuitive symbols, high-contrast colours, readable
            fonts, and tactile elements or Braille translations, aiming to
            enhance accessibility and inclusivity for all users.
          </p>
        </>
      ),
    },
    {
      data1: "Ergonomic Furniture",
      data2: (
        <>
          <p>
            Ergonomic furniture refers to furniture designed to keep the comfort
            and posture of the users in mind, reducing the risk of
            musculoskeletal problems, pain issues, arthritis, restricted organs
            and poor blood pressure.
          </p>
        </>
      ),
    },
    {
      data1: "Evacuation Plan",
      data2: (
        <>
          <p>
            An evacuation plan lays out a pathway for how to exit a building
            safely during an emergency.
          </p>
        </>
      ),
    },
    {
      data1: "Frequency ",
      data2: (
        <>
          <p>
            Frequency refers to the number of cyclical variations per unit of
            time. Frequency is generally expressed in cycles per second (cps)
            and is also denoted as Hertz (Hz).
          </p>
        </>
      ),
    },
    {
      data1: "Green Building",
      data2: (
        <>
          <p>
            Green building design involves designing, constructing, and
            operating buildings with a focus on environmental sustainability and
            resource efficiency. It encompasses strategies to minimise
            environmental impact, conserve resources, and enhance occupant
            health and well-being through the use of energy-efficient systems,
            sustainable materials, and innovative design practices.
          </p>
        </>
      ),
    },
    {
      data1: "Handrail",
      data2: (
        <>
          <p>
            A Handrail is a long, narrow bar of wood or metal that people can
            hold on to for support, especially when going up or down stairs or
            ramps.
          </p>
        </>
      ),
    },
    {
      data1: "HVAC",
      data2: (
        <>
          <p>
            Heating, ventilation, and air conditioning (HVAC) is the use of
            various technologies to control the temperature, humidity, and
            purity of the air in an enclosed space to provide thermal comfort
            and acceptable indoor air quality.
          </p>
        </>
      ),
    },
    {
      data1: "Hydraulic Lifts",
      data2: (
        <>
          <p>
            Hydraulic Lifts refer to devices for moving objects using force
            created by pressure on a liquid inside a cylinder that moves a
            piston upward.
          </p>
        </>
      ),
    },
    {
      data1: "IGBC Building Rating System",
      data2: (
        <>
          <p>
            Indian Green Building Council (IGBC) rating system is a voluntary
            and consensus-based program developed by the Confederation of Indian
            Industry (CII) was formed in the year 2001. The system is developed
            based on materials and technologies that are presently available.
          </p>
        </>
      ),
    },
    {
      data1: "Indigenous Plants",
      data2: (
        <>
          <p>
            Indigenous plants are species native to a specific region or
            ecosystem, naturally occurring and adapted to local environmental
            conditions. They play a vital role in preserving biodiversity,
            supporting native wildlife, and promoting sustainability in
            landscaping and gardening practices.
          </p>
        </>
      ),
    },
    {
      data1: "Indoor Ambient Noise",
      data2: (
        <>
          <p>
            Indoor Ambient Noise is a pervasive noise in a given situation at a
            given time, usually composed of noise from many sources, inside and
            outside the building, but excluding noise from the activities of the
            occupants.
          </p>
        </>
      ),
    },
    {
      data1: "Information & Wayfinding System",
      data2: (
        <>
          <p>
            Information and wayfinding system refers to a wide range of aspects
            and tools designed to enable users to reach, navigate, identify and
            use the built environment.
          </p>
        </>
      ),
    },
    {
      data1: "Inspection Zone",
      data2: (
        <>
          <p>
            nspection Zone refers to the locations near the security gate where
            vehicles are held temporarily for checking them ( for explosives or
            any other threats) before being allowed to the designated
            parking/loading/unloading areas.
          </p>
        </>
      ),
    },
    {
      data1: "IOT Devices",
      data2: (
        <>
          <p>
            Internet of Things (“IOT”) devices are physical objects embedded
            with sensors, software, and other technologies that enable them to
            connect to the internet and exchange data with other devices and
            systems. These devices can range from everyday objects like smart
            thermostats, wearable fitness trackers, and home security cameras to
            industrial machinery, vehicles, and infrastructure components such
            as smart meters and traffic lights.
          </p>
        </>
      ),
    },
    {
      data1: "Internal Environment",
      data2: (
        <>
          <p>
            Internal Environment refers to the environment that is created
            inside buildings, as opposed to the external environment, which
            comprises the environment outside buildings. It may typically be
            formed by its size, form, layout, texture, etc., and includes the air
            quality and acoustic, visual and thermal environment. This
            environment is created by the architecture of the building,
            including its fabric and systems, and as with the broader
            environment, it can affect our comfort, well-being, performance,
            behaviour, growth and development.
          </p>
        </>
      ),
    },
    {
      data1: "Kerb Ramps",
      data2: (
        <>
          <p>
            Kerb ramps are sloped surfaces constructed at curb edges to
            facilitate gradual transitions between sidewalks and
            roadways/driveways, ensuring accessibility for pedestrians,
            including those with mobility aids.
          </p>
        </>
      ),
    },
    {
      data1: "Landscaping",
      data2: (
        <>
          <p>
            Landscaping involves designing and maintaining outdoor spaces to
            enhance their beauty, functionality, and ecological value through
            the arrangement of plants, pathways, and other features.
          </p>
        </>
      ),
    },
    {
      data1: "Last Mile Connectivity",
      data2: (
        <>
          <p>
            Last mile connectivity refers to the ancillary mobility network that facilitates people’s journey from a transportation hub such as a bus stop, metro station, railway station etc. to their final destination. This may include provision of walkable paths and cycling facilities; or availability of shared autos, shuttle buses, e-bikes etc. to connect to the destination.
          </p>
        </>
      ),
    },
    {
      data1: "LEED Rating System",
      data2: (
        <>
          <p>
            The Leadership in Energy and Environmental Design (“LEED”) System is
            a rating system developed by the U.S. Green Building Council
            (“USGBC”) to evaluate the environmental performance of buildings and
            measure their sustainability. It is the world's most widely used
            green building rating system.
          </p>
        </>
      ),
    },
    {
      data1: "Lead Protection System",
      data2: (
        <>
          <p>
            A Lead Protection System is a ballistic shield typically used by Z+
            Security personnel to safeguard their protectees.
          </p>
        </>
      ),
    },
    {
      data1: "Liminal Space",
      data2: (
        <>
          <p>
            Liminal Space refers to all movement passages and temporarily
            occupied zones that serve as in-between spaces or transition zones.
          </p>
        </>
      ),
    },
    {
      data1: "Loading Zone",
      data2: (
        <>
          <p>
            A Loading zone is an area of a street or a parking lot designated
            for the loading or unloading of passengers, baggage or freight, or
            short-term parking for that purpose.
          </p>
        </>
      ),
    },
    {
      data1: "Louver",
      data2: (
        <>
          <p>
            A Louver is a door or window with flat sloping pieces of wood,
            metal, or glass across it to allow light and air to come in while
            keeping rain out.
          </p>
        </>
      ),
    },
    {
      data1: "Low-Volatile Organic Compounds ",
      data2: (
        <>
          <p>
            Low-Volatile Organic Compounds (“VOCs”) are materials or products
            with minimal emissions of organic chemicals, reducing indoor air
            pollution and promoting healthier indoor environments.
          </p>
        </>
      ),
    },
    {
      data1: "Manned Stations",
      data2: (
        <>
          <p>
            Manned stations are designated areas staffed by personnel to assist
            court users, provide directions, and ensure security playing a
            crucial role in facilitating court proceedings and addressing
            inquiries.
          </p>
        </>
      ),
    },
    {
      data1: "Manoeuvring Space",
      data2: (
        <>
          <p>
            Manoeuvring space, in terms of accessibility, refers to the area in
            a building that allows individuals, particularly those using
            mobility aids (wheelchairs, walkers, crutches, etc.), to navigate
            freely. It includes open spaces and corridors, crucial for easy
            movement and direction changes, aligning with universal design
            principles for inclusivity.
          </p>
        </>
      ),
    },
    {
      data1: "Mobile Compactor Storage Systems ",
      data2: (
        <>
          <p>
            Mobile compactor storage systems are movable shelving units mounted
            on tracks or rails to maximise space efficiency. They compact
            together when not in use, increasing storage capacity within the
            same footprint, and can be operated manually or electronically for
            easy access to stored items.
          </p>
        </>
      ),
    },
    {
      data1: "Mezzanine Floor",
      data2: (
        <>
          <p>
            A Mezzanine Floor is an intermediate floor between the main floors
            of a building, and therefore typically not counted among the overall
            floors of a building. Often, a mezzanine is low-ceilinged and
            projects in the form of a balcony.
          </p>
        </>
      ),
    },
    {
      data1: "Modular Structure/Design",
      data2: (
        <>
          <p>
            A Modular Structure is a building that is composed of standardised
            units or modules that can be easily added, removed, or rearranged as
            needed.
          </p>
        </>
      ),
    },
    {
      data1: "Need-Based Access",
      data2: (
        <>
          <p>
            Need-Based Access provides access to stakeholders who visit the
            Court Complex for a particular day and need to access areas beyond
            public access like Mulaqat room (Relatives of Undertrials/Accused),
            press briefing room (Accredited Media), etc.
          </p>
        </>
      ),
    },
    {
      data1: "Noise Reduction Co-efficient (NRC)",
      data2: (
        <>
          <p>
            A Noise Reduction Co-efficient is a single-figure descriptor of the
            sound absorption property of a material. It is the arithmetic mean
            of the sound absorption coefficients at 250, 500, 1000 and 2 000 Hz
            rounded off to the nearest multiple of 0.05.
          </p>
        </>
      ),
    },
    {
      data1: "Octave ",
      data2: (
        <>
          <p>
            Octave is a band of frequencies in which the upper limit of the band
            is twice the frequency of the lower limit.
          </p>
        </>
      ),
    },
    {
      data1: "Open-Plan Layout",
      data2: (
        <>
          <p>
            An Open-Plan Layout in a space refers to a room or building which
            has few or no walls inside, so it is not divided into smaller rooms.
          </p>
        </>
      ),
    },
    {
      data1: "Parking Bay",
      data2: (
        <>
          <p>
            A parking bay is a marked area within a parking lot or garage where
            vehicles can park. It often includes signage indicating details like
            reserved parking, time limits, or accessibility features, and is
            organised to efficiently use available space and ensure orderly
            parking.
          </p>
        </>
      ),
    },
    {
      data1: "Pause Area",
      data2: (
        <>
          <p>
            A pause area is a designated space within a facility or environment
            intended for individuals to take a break, rest, or momentarily pause
            their activities and offers a comfortable environment for relaxation
            and rejuvenation before resuming tasks. Pause areas may include
            seating, greenery, and other essential amenities to promote
            well-being and mental refreshment.
          </p>
        </>
      ),
    },
    {
      data1: "Perimeter Lighting",
      data2: (
        <>
          <p>
            Perimeter Lighting refers to a lighting design technique that
            focuses on illuminating the outer edges or boundaries of a space
          </p>
        </>
      ),
    },
    {
      data1: "Permeable paving",
      data2: (
        <>
          <p>
            Permeable paving refers to pavers that are made of either a porous
            material that enables stormwater to flow through it or nonporous
            blocks spaced so that water can flow between the gaps.
          </p>
        </>
      ),
    },
    {
      data1: "Pictogram",
      data2: (
        <>
          <p>
            A pictogram is a simplified symbol used to represent an object,
            idea, or concept visually, often employed in signage and
            communication to convey information quickly and universally.
          </p>
        </>
      ),
    },
    {
      data1: "RFID",
      data2: (
        <>
          <p>
            RFID (radio frequency identification) is a form of wireless
            communication that incorporates the use of electromagnetic or
            electrostatic coupling in the radio frequency portion of the
            electromagnetic spectrum to uniquely identify objects.
          </p>
        </>
      ),
    },
    {
      data1: "Rain Gardens",
      data2: (
        <>
          <p>
            A Refuge Area refers to a place in a building designed where
            occupants can take shelter during a fire or other emergency when
            evacuation may not be safe or possible.
          </p>
        </>
      ),
    },
    {
      data1: "Refuge Area",
      data2: (
        <>
          <p>
            An Open-Plan Layout in a space refers to a room or building which
            has few or no walls inside, so it is not divided into smaller rooms.
          </p>
        </>
      ),
    },
    {
      data1: "Request for Proposal (RfP)",
      data2: (
        <>
          <p>
            A RfP is a business document that announces a project, describes it
            and solicits bids from qualified contractors to complete it.
          </p>
        </>
      ),
    },
    {
      data1: "Restricted Zone",
      data2: (
        <>
          <p>
            Restricted Zone refers to areas of the Court Complex which are accessible only for permanent staff of the Court System - namely Members of the Judiciary & Court Administrative Staff. Few Operational & Administrative Service providers (like CDAC / CISF / NIC / BSNL Personnel ) may also be given access to this area with special permissions from the court Administration.
          </p>
        </>
      ),
    },
    {
      data1: "Retention Ponds",
      data2: (
        <>
          <p>
            Retention Ponds are used to hold and distribute rain runoff, which
            in turn helps prevent flooding. They are often landscaped with a
            variety of grasses, shrubs, and/or wetland plants to provide bank
            stability.
          </p>
        </>
      ),
    },
    {
      data1: "Retrofitting",
      data2: (
        <>
          <p>
            Retrofitting a building means putting new parts or new equipment in
            it after it has been in use for some time, especially to improve its
            safety or make it work better. It includes the process of upgrading
            or improving the structural integrity, safety, and functionality of
            existing buildings, infrastructure, and other non-structural aspects
            such as fire protection, life safety systems and accessibility
            upgrades. The intent is to adopt measures such as simple repairs,
            renovations, or upgrades to make the building safer, more
            user-friendly, more resilient, and adaptable to the demands of
            modern use or future requirements.
          </p>
        </>
      ),
    },
    {
      data1: "Reverberation Time (T) ",
      data2: (
        <>
          <p>
            Reverberation Time is the time that would be required for the sound
            pressure level to decrease by 60 dB after the sound source has
            stopped. NOTE — Reverberation time is usually measured in octave or
            third octave bands. It is not necessary to measure the decay over
            the full 60 dB range. The decay measured over the range 5 dB to 35
            dB below the initial level is denoted by T30, and over the range 5
            dB to 25 dB below the initial level by T20.
          </p>
        </>
      ),
    },
    {
      data1: "Rollator ",
      data2: (
        <>
          <p>
            A Rollator is a walking frame equipped with wheels, especially one
            designed for the disabled or elderly.
          </p>
        </>
      ),
    },
    {
      data1: "Sanitised Area ",
      data2: (
        <>
          <p>
            Sanitised area refers to the area in the Court premise between the
            perimeter and the main court building where all stakeholders are
            allowed after screening at the entry/exit points
          </p>
        </>
      ),
    },
    {
      data1: "Security Perimeter ",
      data2: (
        <>
          <p>
            Security Perimeter refers to the area on the boundary of the Court
            complex which forms the outermost layer of the court security system
          </p>
        </>
      ),
    },
    {
      data1: "Security Transition Point  ",
      data2: (
        <>
          <p>
            Security Transition Point refers to any entry/exit point that the
            stakeholder crosses to access an area restricted by access
            permissions.
          </p>
        </>
      ),
    },
    {
      data1: "Segregated Entrance ",
      data2: (
        <>
          <p>
            Segregated Entrances refers to the separation of entrances to
            differential access areas within the court complex for different
            stakeholders based on their access privilege.
          </p>
        </>
      ),
    },
    {
      data1: "Seismic Zones ",
      data2: (
        <>
          <p>
            Seismic zones are categorised regions by earthquake vulnerability,
            determined by factors like tectonic activity and past seismic
            events. Each zone receives a numerical designation indicating its
            seismic hazard level, impacting building codes and standards for
            structural resilience against earthquake forces.
          </p>
        </>
      ),
    },
    {
      data1: "Signage ",
      data2: (
        <>
          <p>
            Reverberation Time is the time that would be required for the sound
            pressure level to decrease by 60 dB after the sound source has
            stopped. NOTE — Reverberation time is usually measured in octave or
            third octave bands. It is not necessary to measure the decay over
            the full 60 dB range. The decay measured over the range 5 dB to 35
            dB below the initial level is denoted by T30, and over the range 5
            dB to 25 dB below the initial level by T20.
          </p>
        </>
      ),
    },
    {
      data1: "Silent Duress Alarm",
      data2: (
        <>
          <p>
            Silent Duress Alarm is a safety device used to assist people in an
            emergency or dangerous situation. Duress alarm systems consist of
            wireless mobile devices that keep people connected to the resources
            that will be able to assist them when necessary.
          </p>
        </>
      ),
    },
    {
      data1: "Site-Level Security ",
      data2: (
        <>
          <p>
            Site-level Security in a Court Complex involves measures to protect
            the entire premises, including security protocols, physical
            barriers, surveillance systems, and personnel strategically
            stationed to deter unauthorised access and ensure safety for all.
          </p>
        </>
      ),
    },
    {
      data1: "Spatial Design ",
      data2: (
        <>
          <p>
            Spatial Design refers to the design of human environments,
            particularly interior environments.
          </p>
        </>
      ),
    },
    {
      data1: "Speciality Courtrooms ",
      data2: (
        <>
          <p>
            Speciality Courtrooms are specially designed Courtrooms that cater
            to the specific requirements of special legislations such as POCSO,
            NDPS, etc.
          </p>
        </>
      ),
    },
    {
      data1: "Sound Reverberation (R) ",
      data2: (
        <>
          <p>
            R is the laboratory measure of the sound-insulating properties of a
            material or building element in a stated frequency band.
          </p>
        </>
      ),
    },
    {
      data1: "Stair Landing ",
      data2: (
        <>
          <p>
            A Stair Landing is a flat platform or area between flights of
            stairs, allowing users to change direction or continue ascending or
            descending safely. It serves as a transition point, providing space
            for resting and manoeuvring while moving between different levels of
            a building.
          </p>
        </>
      ),
    },
    {
      data1: "Standoff Perimeter",
      data2: (
        <>
          <p>
            The Standoff Perimeter is the area which forms a sanitised zone
            between the external boundary of the court complex and the internal
            location where occupants of the premise inhabit.
          </p>
        </>
      ),
    },
    {
      data1: "Streetscape ",
      data2: (
        <>
          <p>
            Streetscape refers to the appearance or the design of the streets in a town or city.
          </p>
        </>
      ),
    },
    {
      data1: "Structural Redundancy ",
      data2: (
        <>
          <p>
            Structural redundancy refers to the extra capacity built into a
            structure beyond what is required for its normal use. In case of
            resilient buildings, such redundancy ensures there are multiple
            strategies in place in case one fails during the time of an
            earthquake. Often, structural redundancy is built to accommodate the
            load of additional floors in a building.
          </p>
        </>
      ),
    },
    {
      data1: "Swales ",
      data2: (
        <>
          <p>
            Swales refer to low-lying or depressed and often wet stretches of
            land.
          </p>
        </>
      ),
    },
    {
      data1: "Tactile Paving ",
      data2: (
        <>
          <p>
            Tactile paving consists of six different types of standardised
            paving designs with distinct, raised surface patterns. Visually
            impaired pedestrians can detect the tactile paving slabs underfoot
            or by using a cane and interpret the meaning of these patterns.
          </p>
        </>
      ),
    },
    {
      data1: "TGSI ",
      data2: (
        <>
          <p>
            Warning tactile ground surface indicators (TGSIs) are areas of
            raised surface domes or cones on the ground designed to provide
            pedestrians who are blind or who have a vision impairment with
            warning information about features such as stairs, ramps or hazards.
          </p>
        </>
      ),
    },
    {
      data1: "Universal Design ",
      data2: (
        <>
          <p>
            Universal design is an inclusive approach to designing products,
            environments, and systems that are usable by people of all abilities
            and ages without the need for adaptation. It prioritises
            inclusivity, flexibility, and simplicity to accommodate diverse user
            needs and preferences.
          </p>
        </>
      ),
    },
    {
      data1: "Ventilation systems (light and air ventilation) ",
      data2: (
        <>
          <p>
            Ventilation systems (light and air ventilation) involve effectively
            providing natural illumination and airflow within a building or
            enclosed space. They enhance visibility, regulate temperature,
            remove pollutants, and maintain indoor air quality for the
            occupant's optimal comfort and well-being.
          </p>
        </>
      ),
    },
    {
      data1: "Video Management System ",
      data2: (
        <>
          <p>
            Video Management System refers to the software application or system
            which collates IP cameras and other sensor data feeds from different
            sensor devices to trigger alarms or send notifications for a pre-set
            scenario or design rule.
          </p>
        </>
      ),
    },
    {
      data1: "Visiting Room",
      data2: (
        <>
          <p>
            A Visiting Room is a designated, supervised space within a building
            facility, providing a controlled, supervised space for persons to
            meet visitors securely, equipped with seating and communication
            facilities, and facilitating meaningful interactions with those in
            custody or under care.
          </p>
        </>
      ),
    },
    {
      data1: "Visitor Management System ",
      data2: (
        <>
          <p>
            A Visitor Management System allows the court Administration to give
            an access card (either in the form of an ID or a proximity card) for
            casual visitors to access facilities within the Court premise, after
            verifying their bonafide & confirming their credentials
          </p>
        </>
      ),
    },
    {
      data1: "Volatile Organic Compounds (VOCs) materials ",
      data2: (
        <>
          <p>
            Volatile Organic Compounds (VOCs) are compounds that have a high
            vapour pressure and low water solubility. They release toxic fumes
            and carcinogens into the atmosphere.
          </p>
        </>
      ),
    },
    {
      data1: "Wayfinding System",
      data2: (
        <>
          <p>
            A tool or suite of tools that works to help people navigate their
            physical environments and orient themselves in their location in
            space.
          </p>
        </>
      ),
    },
  ];

  const annexureRowThree = [
    {
      data1: "Able-Bodied ",
      data2: (
        <>
          <p>
            An able-bodied person refers to someone who is healthy and has no
            illness, injury, or condition that makes it difficult to do the
            things that other people do.
          </p>
        </>
      ),
    },
    {
      data1: "Assistive Aid ",
      data2: (
        <>
          <p>
            Assistive Aids are tools and devices used by persons with
            disabilities to improve their quality of life in terms of mobility,
            communication and for performing their daily activities.
          </p>
        </>
      ),
    },
    {
      data1: "Auditory Announcements",
      data2: (
        <>
          <p>
            Auditory announcements are announcements describing the text
            displayed on a screen.
          </p>
        </>
      ),
    },
    {
      data1: "Automated External Defibrillators (“AED”) ",
      data2: (
        <>
          <p>
            An AED, or automated external defibrillator, is a device that is
            used to help those experiencing sudden cardiac arrest.
          </p>
        </>
      ),
    },
    {
      data1: "Ballistic System ",
      data2: (
        <>
          <p>
            A Ballistic Protection System is a ballistic shield typically used
            by Z+ Security personnel to safeguard their protectees.
          </p>
        </>
      ),
    },
    {
      data1: "Carbon Footprint ",
      data2: (
        <>
          <p>
            Carbon Footprint refers to the amount of carbon dioxide emissions
            associated with all the activities of a person or other entity.
          </p>
        </>
      ),
    },
    {
      data1: "Cheriyal Art Form ",
      data2: (
        <>
          <p>
            Cheriyal Art Form is a stylized version of Nakashi art, rich in the
            local motifs which is distinctive to Telangana.
          </p>
        </>
      ),
    },
    {
      data1: "Climate-Responsive Design",
      data2: (
        <>
          <p>
            Climate-responsive Design is a building design that reflects the
            weather conditions in the precise area where the building is
            constructed which utilises data on the region's weather patterns and
            accounts for factors like seasonality, intensity of the sun, wind,
            rainfall and humidity.
          </p>
        </>
      ),
    },
    {
      data1: "Cognitive Impairment",
      data2: (
        <>
          <p>
            Cognitive Impairment refers to problems with a person’s ability to
            think, learn, remember, use judgment, and make decisions.
          </p>
        </>
      ),
    },
    {
      data1: "Diverse User Groups",
      data2: (
        <>
          <p>
            Diverse User Group refers to individuals possessing different traits
            and characteristics, including but not limited to age, colour,
            creed, national origin, race, religion, marital status, sex, sexual
            orientation, gender identity, physical attributes, physical or
            mental ability or disability, ancestry, political party preference,
            political belief, socioeconomic status, or familial status.
          </p>
        </>
      ),
    },
    {
      data1: "Eco-Sensitive Zone",
      data2: (
        <>
          <p>
            The National Environment Policy (2006) defined the Eco-Sensitive
            Zones as “areas/zones with identified environmental resources having
            incomparable values which require special attention for their
            conservation” because of its landscape, wildlife, biodiversity,
            historical and natural values.
          </p>
        </>
      ),
    },
    {
      data1: "Ecological Impact",
      data2: (
        <>
          <p>
            Ecological Impact refers to effects left on organisms and their
            environment due to actions made by humans and natural occurrences.
          </p>
        </>
      ),
    },
    {
      data1: "Energy Conscious Design",
      data2: (
        <>
          <p>
            Energy-conscious design and planning refers to the inclusion of
            energy, embodied energy and energy efficiency in the planning and
            design of the built environment.
          </p>
        </>
      ),
    },
    {
      data1: "Ergonomic",
      data2: (
        <>
          <p>
            Ergonomics is an applied science concerned with designing and
            arranging things people use so that the people and things interact
            most efficiently and safely.
          </p>
        </>
      ),
    },
    {
      data1: "Facility Management Service",
      data2: (
        <>
          <p>
            Facility Management Service is a service that an agency provides to
            manage the comfort, safety, operations, and functionality of a
            facility/building and the personnel to ensure an optimised and
            conducive working environment.
          </p>
        </>
      ),
    },
    {
      data1: "Fire-resistant Evacuation Lifts",
      data2: (
        <>
          <p>
            A Fire-resistant Evacuation Lift is designed to allow firefighters
            to move easily around high-rise buildings in case of an emergency.
          </p>
        </>
      ),
    },
    {
      data1: "IP Camera System",
      data2: (
        <>
          <p>
            IP Camera Systems are Internet Protocol (IP) based Close Circuit
            Camera Systems which enable monitoring, recording and surveillance
            of premises where such devices are deployed
          </p>
        </>
      ),
    },
    {
      data1: "Iconography",
      data2: (
        <>
          <p>
            Iconography is the science of identification, description,
            classification, and interpretation of symbols, themes, and subject
            matter in visual arts.
          </p>
        </>
      ),
    },
    {
      data1: "Micro-Climate",
      data2: (
        <>
          <p>
            Micro-climate refers to a climatic condition in a relatively small
            area, within a few metres or less above and below the Earth’s
            surface and within canopies of vegetation.
          </p>
        </>
      ),
    },
    {
      data1: "Nodal Agency",
      data2: (
        <>
          <p>
            An agency appointed to consult, execute, implement or supervise (or
            a combination of all) a particular task.
          </p>
        </>
      ),
    },
    {
      data1: "Odisha Ikat Art ",
      data2: (
        <>
          <p>
            Odisha Ikat is a kind of ikat, a resist dyeing technique,
            originating from the Indian state of Odisha, adapted from ikat in
            Indonesia.
          </p>
        </>
      ),
    },
    {
      data1: "Oximetry",
      data2: (
        <>
          <p>
            Oximetry is a method that utilises spectrophotometry to measure the
            oxygen saturation of circulating blood or a localised region of
            tissue by means of an oximeter.
          </p>
        </>
      ),
    },
    {
      data1: "Parking Management System ",
      data2: (
        <>
          <p>
            Parking Management Systems are packages to handle vehicle parking
            for named users as well as facilitate parking space management based
            on first-in-first-out rules, either on a time-use basis or
            designated spots for regular users basis.
          </p>
        </>
      ),
    },
    {
      data1: "Passive Design Strategies",
      data2: (
        <>
          <p>
            Passive Design Strategies are design strategies that utilise the
            climate and natural elements to maintain a comfortable internal work
            environment within the building without dependence on mechanical
            systems for heating, cooling and lighting.
          </p>
        </>
      ),
    },
    {
      data1: "Persons with Disabilities",
      data2: (
        <>
          <p>
            The Rights of Persons with Disabilities Act, 2016 defines “person
            with disability” as a person with long-term physical, mental,
            intellectual or sensory impairment which, in interaction with
            barriers, hinders his full and effective participation in society
            equally with others
          </p>
        </>
      ),
    },
    {
      data1: "Phasing Plan",
      data2: (
        <>
          <p>
            Phasing Plan is a project management tool that outlines a schedule
            of actions or tasks to be undertaken throughout the process of
            planning, design, implementation, monitoring and evaluation of a
            project. The plan anticipates future requirements and integrates
            them into the project scope by planning necessary activities and
            budget for the same.
          </p>
        </>
      ),
    },
    {
      data1: "Plug & Play Model",
      data2: (
        <>
          <p>
            Plug & Play Model refers to the technical Term for a model of
            technology deployment which is standardised for interoperability
            between different brands, or competing technologies, hence allowing
            easy use.
          </p>
        </>
      ),
    },
    {
      data1: "Potable Drinking Water",
      data2: (
        <>
          <p>
            Potable Drinking Water refers to water that is suitable for human
            consumption, i.e., water that can be used for drinking or cooking.
          </p>
        </>
      ),
    },
    {
      data1: "Reprographic Services",
      data2: (
        <>
          <p>
            Reprographic Services are methods of reproducing content, such as
            scanning, photography, xerography, and digital printing.
          </p>
        </>
      ),
    },
    {
      data1: "Single Visibility Mirror",
      data2: (
        <>
          <p>
            A single visibility mirror is a reciprocal mirror that appears
            reflective on one side and transparent on the other.
          </p>
        </>
      ),
    },
    {
      data1: "Socio-cultural barriers",
      data2: (
        <>
          <p>
            Socio-cultural barriers are man-made constructs that originate from
            social norms and cultural values which have an adverse impact on
            information-seeking by restricting access to sources and giving rise
            to negative emotions.
          </p>
        </>
      ),
    },
    {
      data1: "Topography",
      data2: (
        <>
          <p>
            Topography refers to the physical features of land, including
            elevation, slope, and terrain, shaping both natural and human-made
            landscapes. Topography plays a crucial role in influencing factors
            such as land use, drainage patterns, and environmental conditions.
          </p>
        </>
      ),
    },
    {
      data1: "Voice Altering Device",
      data2: (
        <>
          <p>
            Voice Altering Devices are devices which can change the tone or
            pitch of or add distortion to the user's voice.
          </p>
        </>
      ),
    },
  ];

  const Abbreviations = [
    {
      data1: "ADR",
      data2: "Alternative Dispute Resolution"
    },
    {
      data1: "AED",
      data2: "Automated External Defibrillator"
    },
    {
      data1: "ANPR",
      data2: "Automatic Number-Plate Recognition"
    },
    {
      data1: "APP",
      data2: "Application"
    },
    {
      data1: "ASHRAE",
      data2: "American Society of Heating, Refrigerating and Air-Conditioning Engineers"
    },
    {
      data1: "BICSI",
      data2: "Building Industry Consulting Service International"
    },
    {
      data1: "BIM",
      data2: "Building Information Modelling"
    },
    {
      data1: "BMS",
      data2: "Building Management System"
    },
    {
      data1: "CDAC",
      data2: "Centre for Development of Advanced Computing"
    },
    {
      data1: "CIS",
      data2: "Case Information System"
    },
    {
      data1: "CISF",
      data2: "Central Industrial Security Force"
    },
    {
      data1: "CRPF",
      data2: "Central Reserve Police Force"
    },
    {
      data1: "CSS",
      data2: "Centrally Sponsored Scheme"
    },
    {
      data1: "DCR",
      data2: "Dedicated Control Room"
    },
    {
      data1: "DCTO",
      data2: "Digital Courts Technology Office"
    },
    {
      data1: "DDMA",
      data2: "District Disaster Management Authority"
    },
    {
      data1: "DFMD",
      data2: "Door Frame Metal Detector"
    },
    {
      data1: "DG",
      data2: "Diesel Generator"
    },
    {
      data1: "DHS",
      data2: "Department of Homeland Security"
    },
    {
      data1: "DLSA",
      data2: "District Legal Services Authorities"
    },
    {
      data1: "DPI",
      data2: "Digital Public Infrastructure"
    },
    {
      data1: "DPR",
      data2: "Detailed Project Report"
    },
    {
      data1: "ECBC",
      data2: "Energy Conservation Building Code"
    },
    {
      data1: "ECG",
      data2: "Echocardiogram"
    },
    {
      data1: "FDA",
      data2: "First Division Assistants"
    },
    {
      data1: "GIGW",
      data2: "Accessibility Guidelines for Indian Government Websites"
    },
    {
      data1: "GP",
      data2: "Government Pleaders"
    },
    {
      data1: "GSICC",
      data2: "Gender Sensitisation & Internal Complaints Committee"
    },
    {
      data1: "HSRP",
      data2: "High-Security Registration Plate"
    },
    {
      data1: "HVAC",
      data2: "Heating, Ventilation and Air Conditioning"
    },
    {
      data1: "ICT",
      data2: "Information & Communication Technologies"
    },
    {
      data1: "IP",
      data2: "Internet Protocol"
    },
    {
      data1: "IRIS",
      data2: "Integrated Review of Infrastructure for Safety"
    },
    {
      data1: "ISPs",
      data2: "Internet Service Providers"
    },
    {
      data1: "JALDI",
      data2: "Justice, Access, and Lowering Delays in India"
    },
    {
      data1: "JIMA",
      data2: "Judicial Infrastructure Management Agency"
    },
    {
      data1: "MEP",
      data2: "Mechanical, Engineering and Plumbing"
    },
    {
      data1: "MoEF",
      data2: "Ministry of Environment and Forest"
    },
    {
      data1: "NC",
      data2: "Noise Creation"
    },
    {
      data1: "NCMS",
      data2: "National Court Management Systems"
    },
    {
      data1: "NCMS 2021",
      data2: "National Court Management System Baseline Report on Court Development and Planning"
    },
    {
      data1: "NCSC",
      data2: "National Centre for State Courts"
    },
    {
      data1: "NDPS",
      data2: "Narcotic Drugs and Psychotropic Substances"
    },
    {
      data1: "NIC",
      data2: "National Informatics Centre"
    },
    {
      data1: "NJTC",
      data2: "National Judicial Technology Council"
    },
    {
      data1: "NRC",
      data2: "Noise Reduction Co-efficient"
    },
    {
      data1: "N-STEP",
      data2: "National Service and Tracking of Electronic Processes"
    },
    {
      data1: "NVR",
      data2: "Network Video Recorder"
    },
    {
      data1: "PA",
      data2: "Public Address"
    },
    {
      data1: "PDJ",
      data2: "Principal District & Sessions Judge"
    },
    {
      data1: "PI",
      data2: "Police Inspector"
    },
    {
      data1: "PIS",
      data2: "Patent Information System"
    },
    {
      data1: "POCSO",
      data2: "Protection of Children from Sexual Offences"
    },
    {
      data1: "PP",
      data2: "Public Prosecutors"
    },
    {
      data1: "PWD",
      data2: "Public Works Department"
    },
    {
      data1: "RFID",
      data2: "Radio Frequency Identification"
    },
    {
      data1: "RFPs",
      data2: "Requests for Proposals"
    },
    {
      data1: "RGNIIPM",
      data2: "Rajiv Gandhi National Institute of Intellectual Property Management"
    },
    {
      data1: "RWH",
      data2: "Rain Water Harvesting"
    },
    {
      data1: "SAN",
      data2: "Storage Area Network"
    },
    {
      data1: "SDA",
      data2: "Second Division Assistants"
    },
    {
      data1: "SDGs",
      data2: "Sustainable Development Goal"
    },
    {
      data1: "SMART",
      data2: "Specific, Measurable, Achievable, Relevant, and Time-bound"
    },
    {
      data1: "SOPs",
      data2: "Standard Operating Procedures"
    },
    {
      data1: "SSICT",
      data2: "Security Systems and Information & Communication Technologies"
    },
    {
      data1: "STC",
      data2: "Sound Transmission Class"
    },
    {
      data1: "STI",
      data2: "Speech Transmission Index"
    },
    {
      data1: "TGSIs",
      data2: "Tactile Ground Surface Indicators"
    },
    {
      data1: "TIA",
      data2: "Telecommunications Industry Association"
    },
    {
      data1: "TTS",
      data2: "Text-To-Speech"
    },
    {
      data1: "URDPFI",
      data2: "Urban and Regional Development Plans Formulation and Implementation"
    },
    {
      data1: "VMS",
      data2: "Visitor Management System"
    },
    {
      data1: "VWDC",
      data2: "Vulnerable Witness Deposition Centre"
    },
    {
      data1: "VOCs",
      data2: "Volatile Organic Compounds"
    },

  ];

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    "& .MuiAccordionSummary-content": {
      margin: "0 !important",
    },
    "& .Mui-expanded": {
      margin: theme.spacing(0),
    },
  }));
  const scrollToAccordion = (panelRef, panel) => {
    if (panelRef && panelRef.current) {
      panelRef.current.scrollIntoView({
        block: "center",
        inline: "center",
        behavior: "smooth",
      });
      setTimeout(() => {
        setExpanded(panel);
      }, 0);
    }
  };

  return (
    <div>
      <h1 id="GlossaryMainHead" style={h1style}>
        Glossary
      </h1>{" "}
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        className="glossary-btn-box"
      >
        <Button
          variant="outlined"
          className={`annexure-btn ${activeButton === "panel1Ref" ? "annexure-btn-active" : ""
            }`}
          onClick={() => {
            scrollToAccordion(panel1Ref, "panel1");
            setActiveButton("panel1Ref");
          }}
        >
          Glossary 1
        </Button>

        <Button
          variant="outlined"
          className={`annexure-btn ${activeButton === "panel2Ref" ? "annexure-btn-active" : ""
            }`}
          sx={{ margin: "10px" }}
          onClick={() => {
            setActiveButton("panel2Ref");
            scrollToAccordion(panel2Ref, "panel2");
          }}
        >
          Glossary 2
        </Button>

        <Button
          variant="outlined"
          className={`annexure-btn ${activeButton === "panel3Ref" ? "annexure-btn-active" : ""
            }`}
          onClick={() => {
            scrollToAccordion(panel3Ref, "panel3");
            setActiveButton("panel3Ref");
          }}
        >
          Glossary 3
        </Button>

        <Button
          variant="outlined"
          className={`annexure-btn ${activeButton === "panel4Ref" ? "annexure-btn-active" : ""
            }`}
          sx={{ margin: "10px" }}
          onClick={() => {
            scrollToAccordion(panel4Ref, "panel4");
            setActiveButton("panel4Ref");
          }}
        >
          Abbreviations
        </Button>
      </Box>
      <Accordion
        className="accordion"
        ref={panel1Ref}
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <CustomAccordionSummary
          expandIcon={
            expanded === "panel1" ? (
              <RemoveCircleOutlineIcon className="removeIcon" />
            ) : (
              <AddCircleOutlineIcon className="addIcon" />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ margin: "0px !important" }}
          className="accordian-summary"
        >
          <h2 id="HeadingAnnexure1" className="annexure-heading">
            Glossary I: Glossary of Legal Terms
          </h2>
        </CustomAccordionSummary>
        <AccordionDetails className="accordian-details">
          <GlossaryTable
            isBold={true}
            // tableHeader={annexureHeaderOne}
            rows={annexureRowOne}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="accordion"
        ref={panel2Ref}
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <CustomAccordionSummary
          expandIcon={
            expanded === "panel2" ? (
              <RemoveCircleOutlineIcon className="removeIcon" />
            ) : (
              <AddCircleOutlineIcon className="addIcon" />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ margin: "0px !important" }}
          className="accordian-summary"
        >
          <h2 id="HeadingAnnexure1" className="annexure-heading">
            Glossary II: Glossary of Architectural Terms
          </h2>
        </CustomAccordionSummary>
        <AccordionDetails className="accordian-details">
          <GlossaryTable
            isBold={true}
            // tableHeader={annexureHeaderOne}
            rows={annexureRowTwo}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="accordion"
        ref={panel3Ref}
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <CustomAccordionSummary
          expandIcon={
            expanded === "panel3" ? (
              <RemoveCircleOutlineIcon className="removeIcon" />
            ) : (
              <AddCircleOutlineIcon className="addIcon" />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ margin: "0px !important" }}
          className="accordian-summary"
        >
          <h2 id="HeadingAnnexure1" className="annexure-heading">
            Glossary III: Glossary of Miscellaneous Terms
          </h2>
        </CustomAccordionSummary>
        <AccordionDetails className="accordian-details">
          <GlossaryTable
            isBold={true}
            rows={annexureRowThree}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="accordion"
        ref={panel4Ref}
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <CustomAccordionSummary
          expandIcon={
            expanded === "panel4" ? (
              <RemoveCircleOutlineIcon className="removeIcon" />
            ) : (
              <AddCircleOutlineIcon className="addIcon" />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ margin: "0px !important" }}
          className="accordian-summary"
        >
          <h2 id="HeadingAnnexure1" className="annexure-heading">
            Abbreviations
          </h2>
        </CustomAccordionSummary>
        <AccordionDetails className="accordian-details">
          <GlossaryTable
            rows={Abbreviations}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Glossary;
